export const actions = {
    GET_USER_HOME_CALENDAR_ACTIVITIES: 'GET_USER_HOME_CALENDAR_ACTIVITIES',
    SET_USER_HOME_CALENDAR_ACTIVITIES: 'SET_USER_HOME_CALENDAR_ACTIVITIES',
    GET_USER_HOME_MY_COURSES: 'GET_USER_HOME_MY_COURSES',
    SET_USER_HOME_MY_COURSES: 'SET_USER_HOME_MY_COURSES',
    GET_USER_UPCOMING_ACTIVITIES: 'GET_USER_UPCOMING_ACTIVITIES',
    SET_USER_UPCOMING_ACTIVITIES: 'SET_USER_UPCOMING_ACTIVITIES',
    CLEAR_USER_UPCOMING_ACTIVITIES : 'CLEAR_USER_UPCOMING_ACTIVITIES',
    SET_SEARCH_FILTERS : 'SET_SEARCH_FILTERS'
};
